import React, { useState } from 'react';
import { Button, Typography } from 'antd';
var url = 'https://cryptosheets-stream-prod.azurewebsites.net/api/export';
var body = {
  dataSource: {
    type: 'api',
    config: {
      url: 'https://graphql.bitquery.io/',
      method: 'POST',
      data: {
        operationName: null,
        variables: {
          limit: 10,
          offset: 0,
          network: 'ethereum',
          from: '2020-10-26',
          till: null,
          dateFormat: '%Y-%m-%d'
        },
        query: 'query ($network: EthereumNetwork!, $limit: Int!, $offset: Int!, $from: ISO8601DateTime, $till: ISO8601DateTime) {\n  ethereum(network: $network) {\n    blocks(options: {desc: "height", limit: $limit, offset: $offset}, date: {since: $from, till: $till}) {\n      timestamp {\n        time(format: "%Y-%m-%d %H:%M:%S")\n        __typename\n      }\n      height\n      transactionCount\n      address: miner {\n        address\n        annotation\n        __typename\n      }\n      reward\n      rewardCurrency {\n        symbol\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n}\n'
      }
    }
  },
  exportTo: {
    type: 'google sheet',
    params: {
      fileName: 'Latest Blocks'
    }
  }
};
var config = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(body)
};
export default function ExportButton() {
  var [loading, setLoading] = useState(false);

  function handleExport() {
    setLoading(true);
    return fetch(url, config).then(response => response.json()).then((_ref) => {
      var {
        objectUrl
      } = _ref;
      // Set clickable a element to open in new tab
      var a = document.createElement('a');
      a.setAttribute('href', objectUrl);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
      document.body.appendChild(a); // required for firefox

      a.click();
      a.remove();
    }).then(() => setLoading(false)).catch(() => setLoading(false));
  }

  return /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    onClick: () => handleExport()
  }, "Export");
}